import React from "react";
import { FormattedMessage } from "react-intl";
import { CSSProperties } from "react";

import defaultStyle from "./BlockContainer.module.scss";

interface BlockContainerMetadata {
  title?: string;
  subtitle?: string;
  infoSrc?: string;
}

export interface BlockContainerOptions {
  metadata?: BlockContainerMetadata;
  styles?: CSSProperties;
}

export interface BlockContainerProps extends BlockContainerOptions {
  children: React.ReactNode;
}

export const BlockContainer: React.FC<BlockContainerProps> = (props: BlockContainerProps) => {
  const { metadata, styles } = props;

  return (
    <div className={defaultStyle.blockContainer}>
      <div className={defaultStyle.content}>
        <div className={defaultStyle.contentElement} style={styles}>
          {props.children}
        </div>
      </div>

      {(metadata?.title || metadata?.subtitle || metadata?.infoSrc) && (
        <div className={defaultStyle.metadata}>
          {metadata.title && <h6 className={defaultStyle.title}>{metadata.title}</h6>}
          {metadata.subtitle && <p className={defaultStyle.subtitle}>{metadata.subtitle}</p>}
          {metadata.infoSrc && (
            <p className={defaultStyle.infoSrc}>
              <span>
                <FormattedMessage id="blockContainer.sourceInfo" defaultMessage="Source:" />{" "}
              </span>
              {metadata.infoSrc}
            </p>
          )}
        </div>
      )}
    </div>
  );
};
